import { render, staticRenderFns } from "./Received.vue?vue&type=template&id=1fbc6da8&scoped=true&"
import script from "./Received.vue?vue&type=script&lang=js&"
export * from "./Received.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbc6da8",
  null
  
)

export default component.exports